import React from 'react';
import { Document } from '@react-pdf/renderer';
import { PrintDataFields } from '@repo/print-pdf/arbre/print';

import type { PrintTemplate } from '@repo/types';
import { getPrintHeaderVariant } from '../../print/utils';
import { PDFDocument } from '../one';
import { PdfPrintTemplate } from '../template';

interface MultiPDFDocumentProps {
  printDataList: PrintDataFields[];
  arbreIds: number[];
  /** Modèle de fiche : appliqué aux arbres ; les autres types (alignement) gardent leur fiche actuelle. */
  template?: PrintTemplate;
}

export const MultiPDFDocument: React.FC<MultiPDFDocumentProps> = ({
  printDataList,
  arbreIds,
  template,
}) => {

  const renderFiche = (data: PrintDataFields, inventaireId: number) => {

    const useTemplate = template && getPrintHeaderVariant(data.inventaireType) === 'primary';

    return (
      <React.Fragment key={`${inventaireId}`}>
        {useTemplate ? (
          <PdfPrintTemplate template={template} data={data} inventaireId={inventaireId} />
        ) : (
          <PDFDocument data={data} inventaireId={inventaireId} />
        )}
      </React.Fragment>
    );
  };

  return (
    <Document>
      {printDataList.map((data, index) => renderFiche(data, arbreIds[index] || index))}
    </Document>
  );
};

